export default function LoadingState({ text = "内容加载中…" }: { text?: string }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-foreground-500">
      <span className="w-12 h-12 flex items-center justify-center">
        <i className="ri-loader-4-line text-4xl animate-spin text-primary-500"></i>
      </span>
      <p className="mt-4 text-sm">{text}</p>
    </div>
  );
}